import { render, staticRenderFns } from "./container-item-wrapper.vue?vue&type=template&id=dfacd57e&scoped=true"
import script from "./container-item-wrapper.vue?vue&type=script&lang=js"
export * from "./container-item-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfacd57e",
  null
  
)

export default component.exports